module.exports = __webpack_public_path__ + "static/media/cdao.0c22b431.webp";